export * from './actions';
export * from './effects';
export * from './service';

export {
  featureKey as validateZipCodeKey,
  initialState as validateZipCodeInitialState,
  State as ValidateZipCodeState,
} from './reducer';

export {
  getData as validateZipCodeGetData,
  getError as validateZipCodeGetError,
  getLoading as validateZipCodeGetLoading,
  mapData as validateZipCodeMapData,
} from './selectors';
